import type { OrdenTabla } from "../hooks/useTablaBandeja";

/**
 * Encabezado de columna clickeable para ordenar. Muestra la flecha solo en la
 * columna activa, para que se vea de un golpe por qué está ordenada la tabla.
 */
interface Props<T> {
  columna: keyof T & string;
  orden: OrdenTabla<T>;
  onOrdenar: (columna: keyof T & string) => void;
  children: React.ReactNode;
  /** Alineación a la derecha para columnas de importes. */
  alineado?: "izquierda" | "derecha";
}

export function ThOrdenable<T>({ columna, orden, onOrdenar, children, alineado = "izquierda" }: Props<T>) {
  const activa = orden.columna === columna;
  const flecha = activa ? (orden.direccion === "asc" ? "↑" : "↓") : "";

  return (
    <th
      className={`th-ordenable${activa ? " th-activa" : ""}${alineado === "derecha" ? " th-derecha" : ""}`}
      onClick={() => onOrdenar(columna)}
      title="Ordenar por esta columna"
    >
      {children}
      <span className="th-flecha">{flecha}</span>
    </th>
  );
}
